import {
  ADD_TAG,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE, STOP_TAG_LOADER,
  TOGGLE_COLLAPSED_NAV, UPDATE_TAG
} from '../constants/ActionTypes'

const INIT_STATE = {
  error: "",
  loading: false,
  navCollapsed: false,
  message: '',
  loadingAddTag: {},
  loadingAddTagError: {},
  loadingUpdateTag: {},
  loadingUpdateTagError: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
    return {
      ...state,
      navCollapsed: false
    };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.isNavCollapsed
      };
    case FETCH_START: {
      return {...state, error: '', message: '', loading: true};
    }
    case FETCH_SUCCESS: {
      return {...state, error: '', message: '', loading: false};
    }
    case SHOW_MESSAGE: {
      return {...state, error: '', message: action.payload, loading: false};
    }
    case FETCH_ERROR: {
      return {...state, loading: false, error: action.payload, message: ''};
    }
    case HIDE_MESSAGE: {
      return {...state, loading: false, error: '', message: ''};
    }

      /***********************************
       * ADD_TAG
       ***********************************/

    case ADD_TAG: {
      const affectedElementId = action.payload.affectedElementId

      console.log("Running addTag with this affectedElementId for loader:", affectedElementId, "from payload", action.payload);

      return {
        ...state,
        // loadingAddTag: {
        //   ...state.loadingAddTag,
        //   [affectedElementId] : true,
        // },
        // loadingAddTagError: {
        //   ...state.loadingAddTagError,
        //   [affectedElementId] : false,
        // },
        //
      }
    }

      /***********************************
       * UPDATE_TAG
       ***********************************/

    case UPDATE_TAG: {
      const tagId = action.payload.tagId
      return {
        ...state,
        // loadingUpdateTag: {
        //   ...state.loadingUpdateTag,
        //   [tagId] : true,
        // },
        // loadingUpdateTagError: {
        //   ...state.loadingUpdateTagError,
        //   [tagId] : false,
        // },
      }
    }

      /***********************************
       * STOP_TAG_LOADER
       ***********************************/

    case STOP_TAG_LOADER: {
      console.log("(Reducer) Stopping tag loader with payload", action.payload);
      const stopId = action.payload.id
      const didFail = action.payload.didFail
      return {
        ...state,
        loadingUpdateTag: {
          ...state.loadingUpdateTag,
          [stopId] : false,
        },
        loadingUpdateTagError: {
          ...state.loadingUpdateTagError,
          [stopId] : didFail,
        },
        loadingAddTag: {
          ...state.loadingAddTag,
          [stopId] : false,
        },
        loadingAddTagError: {
          ...state.loadingAddTagError,
          [stopId] : didFail,
        },
      }
    }

    default:
      return state;
  }
}
